import { Link } from "react-router-dom";

// The hub menu at /. One card per sub-app; add new ones here. external: a standalone page
// served by Express (not a React route), so it needs a full page load, not a <Link>.
const APPS = [
  { to: "/rowing", title: "Rowing School Finder", blurb: "Katie's list of NCAA women's rowing programs." },
  { to: "/pt", title: "PT Micro-Internship", blurb: "Clinics for Katie's February 2027 externship week." },
  { to: "/cambridge", title: "Head of the Charles", blurb: "Trip map for Cambridge.", external: true },
  { to: "/toolz", title: "TOOLZ", blurb: "Tim's bookmarks dashboard.", external: true },
];

export default function HomePage() {
  return (
    <div className="mx-auto max-w-3xl p-3 sm:p-4">
      <header className="mb-4">
        <h1 className="text-xl font-bold">timtwhit</h1>
      </header>
      <div className="grid gap-3 sm:grid-cols-2">
        {APPS.map((a) => {
          const body = (
            <>
              <div className="font-semibold">{a.title}</div>
              <p className="mt-1 text-sm text-slate-600">{a.blurb}</p>
            </>
          );
          const cls = "card block text-inherit no-underline hover:bg-slate-50";
          return a.external ? (
            <a key={a.to} href={a.to} className={cls}>
              {body}
            </a>
          ) : (
            <Link key={a.to} to={a.to} className={cls}>
              {body}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
